module.exports = __webpack_public_path__ + "img/symbol_4.696b011c.png";